import * as React from 'react';
import * as DOMPurify from 'isomorphic-dompurify';
import linkifyHtml from 'linkify-html';
import { Text } from 'wix-ui-tpa';
import { classes } from './ExpandedSummary.st.css';
import { DEMO_CALENDARS_IDS } from '../../../constants';
var ExpandedSummary = function (_a) {
    var isDetailsVisible = _a.isDetailsVisible, summary = _a.summary, calendarId = _a.calendarId;
    var summaryRef = React.useRef(null);
    React.useEffect(function () {
        if (summaryRef.current) {
            //@ts-ignore
            var matches = summaryRef.current.querySelectorAll('a');
            matches.length > 0 &&
                matches.forEach(function (element) {
                    element.setAttribute('tabIndex', '1');
                });
        }
    }, []);
    var convertToLinkifyHtml = function (summary) {
        var origSummary = summary;
        try {
            summary = linkifyHtml(summary, { target: '_blank' });
        }
        catch (error) {
            return origSummary;
        }
        return summary || origSummary;
    };
    var summaryArr = convertToLinkifyHtml(summary).split('\n');
    if (!isDetailsVisible && !DEMO_CALENDARS_IDS.includes(calendarId)) {
        return null;
    }
    return (React.createElement(React.Fragment, null, summary ? (React.createElement(React.Fragment, null,
        React.createElement(Text, { className: classes.Summary },
            React.createElement("span", { ref: summaryRef }, summaryArr.map(function (p, i) { return (React.createElement("div", { key: i, dangerouslySetInnerHTML: { __html: DOMPurify.sanitize(p, { ADD_ATTR: ['target'] }) } })); }))))) : null));
};
export default React.memo(ExpandedSummary);
//# sourceMappingURL=ExpandedSummary.js.map